import * as React from "react"
import {ButtonSeeker} from "@ui-seeker/core";

import {repricingAlertsClicked} from "../../@signals"

export default function RepricingClearFilters() {

	if (repricingAlertsClicked.value.length < 2)
		return <></>

	return <ButtonSeeker
		variant="outlined"
		sx={{ ml: 1, width: .35 }}
		onClick={() => repricingAlertsClicked.value = []}
	>
		Clear Filters
	</ButtonSeeker>
}